<template>
  <div class="common-bg" style="width: 100%; min-height: 100vh; background: #1a1a1a;">
    <van-nav-bar fixed title="我的折扣券" left-arrow @click-left="$router.back()" />
    <div style="height: 46px"></div>

    <div class="coupon-tabs">
      <div class="coupon-tab" :class="{ active: activeTab === 0 }" @click="activeTab = 0">未使用</div>
      <div class="coupon-tab" :class="{ active: activeTab === 1 }" @click="activeTab = 1">已使用</div>
      <div class="coupon-tab" :class="{ active: activeTab === 2 }" @click="activeTab = 2">已失效</div>
    </div>

    <div class="coupon-empty" v-if="list.length === 0">
      <div class="empty-icon-wrap">
        <img src="/static/image/img_none_sj.avif" class="empty-icon" alt="" />
      </div>
      <div class="empty-text">暂无可用折扣券，<span class="empty-link" @click="$parent.goNav('/activity')">可查看更多</span></div>
    </div>

    <div class="coupon-list" v-else>
      <div class="coupon-item" v-for="(item, index) in list" :key="index">
        <div class="coupon-left">
          <div class="coupon-discount">{{ item.discount }}</div>
          <div class="coupon-condition">{{ item.condition }}</div>
        </div>
        <div class="coupon-right">
          <div class="coupon-name">{{ item.name }}</div>
          <div class="coupon-expire">有效期至：{{ item.expire_time }}</div>
          <div class="coupon-btn" v-if="activeTab === 0">立即使用</div>
          <div class="coupon-status" v-else>{{ activeTab === 1 ? '已使用' : '已失效' }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'coupon',
  data() {
    return {
      activeTab: 0,
      list: [],
    };
  },
  created() {
    // 暂时不请求接口
  },
  methods: {
    // getData() {
    //   this.$parent.showLoading();
    //   this.$apiFun.post('/api/couponList', { status: this.activeTab }).then(res => {
    //     this.$parent.hideLoading();
    //     if (res.code === 200) {
    //       this.list = res.data || [];
    //     } else {
    //       this.list = [];
    //     }
    //   }).catch(() => {
    //     this.$parent.hideLoading();
    //     this.list = [];
    //   });
    // },
  },
  watch: {
    activeTab() {
      // this.getData();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../static/css/common.css';

.coupon-tabs {
  display: flex;
  background: #1a1a1a;
  padding: 0 0.3rem;

  .coupon-tab {
    padding: 0.3rem 0.4rem;
    color: #999;
    font-size: 0.3rem;
    position: relative;
    cursor: pointer;

    &.active {
      color: #DFB372;

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0.1rem;
        right: 0.1rem;
        height: 2px;
        background: #DFB372;
      }
    }
  }
}

.coupon-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 0;

  .empty-icon-wrap {
    width: 3.5rem;
    height: 3.5rem;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.05);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0.4rem;

    .empty-icon {
      width: 2.5rem;
      height: 2.5rem;
      opacity: 0.5;
    }
  }

  .empty-text {
    font-size: 0.28rem;
    color: #666;

    .empty-link {
      color: #DFB372;
      cursor: pointer;
    }
  }
}

.coupon-list {
  padding: 0.2rem 0.3rem;
}

.coupon-item {
  display: flex;
  background: #292A2C;
  border-radius: 0.2rem;
  margin-bottom: 0.2rem;
  overflow: hidden;

  .coupon-left {
    width: 2rem;
    background: #3D3A2E;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0.3rem 0;

    .coupon-discount {
      color: #DFB372;
      font-size: 0.5rem;
      font-weight: bold;
    }

    .coupon-condition {
      color: #999;
      font-size: 0.22rem;
      margin-top: 0.1rem;
    }
  }

  .coupon-right {
    flex: 1;
    padding: 0.25rem 0.3rem;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .coupon-name {
      color: #fff;
      font-size: 0.3rem;
      margin-bottom: 0.1rem;
    }

    .coupon-expire {
      color: #666;
      font-size: 0.22rem;
      margin-bottom: 0.15rem;
    }

    .coupon-btn {
      display: inline-block;
      background: #DFB372;
      color: #000;
      font-size: 0.24rem;
      padding: 0.1rem 0.3rem;
      border-radius: 0.1rem;
      text-align: center;
      width: fit-content;
      cursor: pointer;
    }

    .coupon-status {
      color: #666;
      font-size: 0.24rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/coupon.vue